import * as React from 'react';

type SectionHeaderProps = {
    title: string;
    description?: string;
};

const WebinarsSectionHeader = (props: SectionHeaderProps) => {
    const { title, description } = props;

    return (
        <div className="w-full py-5 flex justify-between items-center flex-grow-0 flex-shrink-0">
            <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 gap-3">
                <div className="flex flex-col justify-start items-start flex-grow-0 flex-shrink-0 gap-2.5">
                    <div className="flex justify-start items-center flex-grow-0 flex-shrink-0 relative">
                        <p className="text-3xl font-semibold text-left capitalize text-dark">{title}</p>
                    </div>
                </div>
                {description && (
                    <div className="hidden md:flex justify-start items-start flex-grow-0 flex-shrink-0 relative gap-2.5">
                        <p className="text-light-gray">{description}</p>
                    </div>
                )}
            </div>
        </div>
    );
};

export default WebinarsSectionHeader;
